import createWithBsPrefix from "react-bootstrap/createWithBsPrefix"

const NavGroup = createWithBsPrefix("nav-group")
const NavGroupHeader = createWithBsPrefix("nav-group-header")
const NavGroupContent = createWithBsPrefix("nav-group-content")
const NavGroupItem = createWithBsPrefix("nav-group-item", { Component: "a" })

/** export */
export default Object.assign(NavGroup, {
  Header: NavGroupHeader,
  Content: NavGroupContent,
  Item: NavGroupItem,
})
